import { Search, Menu } from 'lucide-react';
import { NotificationBell } from './NotificationBell';
import { UserMenu } from './UserMenu';

export function TopNav() {
  return (
    <header className="sticky top-0 z-40 w-full bg-surface/60 backdrop-blur-md border-b border-border-subtle flex items-center justify-between px-6 md:px-10 py-4 transition-all duration-300">
      <div className="flex items-center gap-4 flex-1 max-w-xl">
        <Menu className="md:hidden text-on-surface w-6 h-6" />
        <div className="relative w-full">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-on-surface-variant w-4 h-4" />
          <input 
            className="w-full bg-surface-container-low border border-border-subtle rounded-xl pl-10 pr-4 py-2 focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none text-sm transition-all" 
            placeholder="Global Search..." 
            type="text" 
          />
        </div>
      </div>
      <div className="flex items-center gap-6 ml-4">
        <div className="hidden lg:flex items-center gap-2 bg-surface-container-high px-3 py-1.5 rounded-full border border-border-subtle">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
          <span className="text-[10px] font-bold text-on-surface-variant tracking-wider uppercase">AI Engine Active</span>
        </div>
        <NotificationBell />
        <UserMenu />
      </div>
    </header>
  );
}
